import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Context is very important in the study of soundscape, as it can influence our reaction to sounds. A sound can be perceived as annoying if it emanates from a factory. The same sound can be perceived as pleasant if it emanates from a natural source such as a fountain.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colsSize: [2, 1],
      gap: "3%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/28/principle/context-1.png`,
                  styles: {
                    maxWidth: "390px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Sound sample",
                  shape: "round",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  url: `${config.ASSETS_URL}/02/28/principle/context-dependent-noise.wav`,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/28/principle/context-2.png`,
                  styles: {
                    maxWidth: "390px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Sound sample",
                  shape: "round",
                  icon: "cis-volume-high",
                  theme: "secondary",
                  url: `${config.ASSETS_URL}/02/28/principle/context-dependent-noise.wav`,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
